export const translationEs = 
{
    es: {
      or: "O",
      back: "Volver",
      close: "Cerrar",
      menu: {
        files: "Mis archivos",
        web: "Dirección web"},
        
    local: {
      browse: "Buscar",
      dd_title_single: "Arrastra y suelta un activo aquí",
      dd_title_multi: "Arrastra y suelta varios activos aquí",
      drop_title_single: "Arrastra un archivo para subir",
      drop_title_multiple: "Arrastra varios archivos para subir"},
      url: {
        inner_title: "Dirección URL de su archivo",
      },
      crop: {
          title: "Arrastra tu imagen",
        },

        queue: {
            title: "Subir archivo",
            title_uploading_with_counter: "Subidos {{num}} archivos",
            abort_all: "Cancelar todo",
            done: "Listo",
            upload_more: "Subir más",
        },
    },
  }

  export const stylesColor={
    palette: {
      window: "rgb(20, 21, 24)",
      windowBorder: "rgb(73, 122, 166)",
      tabIcon: "rgb(255, 49, 90)",
      menuIcons: "#f5f5f5",
      textDark: "rgb(20, 21, 24)",
      textLight: "f5f5f5",
      link:  " rgb(255, 20, 67)",
      action:  " rgb(255, 20, 67)",
      inactiveTabIcon: "rgb(39, 99, 151)",
      error: "#F44235",
      inProgress: "rgb(255, 49, 90)",
      complete: "#C63B8E ",
      sourceBg: "FFF"
    },
  }